import { ReactNode } from 'react';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';

import { PoweredByWatermark, NavigationBar, Page, PageContent } from '@ocx/ui';

import { messages } from '../../signup.messages';

type SignupWithLinkLayoutProps = {
  children: ReactNode;
};

export const SignupWithLinkLayout = ({ children }: SignupWithLinkLayoutProps) => {
  return (
    <Page>
      <HtmlTitle title={messages['signUpWithLink:htmlTitle']} />
      <NavigationBar center={<VendorLogo />} />
      <PageContent bgcolor="background.paper">
        {children}
        <PoweredByWatermark />
      </PageContent>
    </Page>
  );
};
